import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Box,
  Grid
} from '@mui/material';

interface ContextItem {
  id: number;
  title: string;
  items: string[];
}

const KenyanContext: React.FC = () => {
  const contextData: ContextItem[] = [
    {
      id: 1,
      title: 'Meal Times',
      items: [
        'Breakfast: 7:30-8:30 AM',
        'Mid-Morning: 10:00 AM',
        'Lunch: 12:30-1:30 PM'
      ]
    },
    {
      id: 2,
      title: 'Local Staples',
      items: [
        'Ugali, Rice, Beans',
        'Sukuma Wiki, Cabbage',
        'Githeri, Chapati'
      ]
    },
    {
      id: 3,
      title: 'Nutrition Focus',
      items: [
        'Fortified Foods',
        'Vitamin A, Iron, Zinc',
        'Balanced Energy'
      ]
    },
    {
      id: 4,
      title: 'Cultural Considerations',
      items: [
        'Halal Options',
        'Regional Preferences',
        'Seasonal Availability'
      ]
    }
  ];

  return (
    <Card
      sx={{
        mb: 3,
        background: 'linear-gradient(135deg, #FF6B35 0%, #F7931E 100%)',
        color: 'white',
        boxShadow: '0 10px 30px rgba(0,0,0,0.15)',
        borderRadius: 3
      }}
    >
      <CardContent>
        <Typography variant="h6" gutterBottom sx={{ mb: 3, fontWeight: 'bold' }}>
          🇰🇪 Kenyan School Feeding Program Context
        </Typography>

        <Grid container spacing={2}>
          {contextData.map((context) => (
            <Grid item xs={12} sm={6} md={3} key={context.id}>
              <Box
                sx={{
                  backgroundColor: 'rgba(255,255,255,0.15)',
                  p: 2,
                  borderRadius: 2,
                  backdropFilter: 'blur(10px)'
                }}
              >
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1.5 }}>
                  {context.title}
                </Typography>
                {context.items.map((item, index) => (
                  <Typography key={index} variant="body2" sx={{ mb: 0.5 }}>
                    {item}
                  </Typography>
                ))}
              </Box>
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default KenyanContext;
